import 'css-chunksrc/client/scenes/list/styles.scss';export default {
  "list": "_list_18wvu_1",
  "listLoading": "_listLoading_18wvu_10",
  "loader": "_loader_18wvu_16",
  "loaderMain": "_loaderMain_18wvu_30",
  "main": "_main_18wvu_37",
  "content": "_content_18wvu_43",
  "secondaryCriteria": "_secondaryCriteria_18wvu_49",
  "label": "_label_18wvu_54",
  "row": "_row_18wvu_60",
  "configurationIconBox": "_configurationIconBox_18wvu_71",
  "configurationIcon": "_configurationIcon_18wvu_71",
  "scrollWrapper": "_scrollWrapper_18wvu_89",
  "timeline": "_timeline_18wvu_98",
  "timestamp": "_timestamp_18wvu_105",
  "comments": "_comments_18wvu_113",
  "header": "_header_18wvu_121",
  "contentHeader": "_contentHeader_18wvu_134",
  "title": "_title_18wvu_143",
  "rightContent": "_rightContent_18wvu_151",
  "rightContentMultiProject": "_rightContentMultiProject_18wvu_157",
  "contentProjectRedirection": "_contentProjectRedirection_18wvu_161",
  "contentModal": "_contentModal_18wvu_165",
  "attachments": "_attachments_18wvu_170",
  "contextualMenu": "_contextualMenu_18wvu_174",
  "contextualMenuMultiProject": "_contextualMenuMultiProject_18wvu_180",
  "folderIcon": "_folderIcon_18wvu_184",
  "icon": "_icon_18wvu_188",
  "scenePlaceholder": "_scenePlaceholder_18wvu_194"
};